import { AutogenModelHubtranControl, AutogenRowHubtranControl } from "./autogen/AutogenModelHubtranControl";

export class ModelHubtranControl extends AutogenModelHubtranControl<RowHubtranControl> {
	constructor() {
		super(RowHubtranControl);
	}
}

export class RowHubtranControl extends AutogenRowHubtranControl {
}